export default __webpack_public_path__ + "static/media/fireup-with-bg-remove.ee1d348e.png";